import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { BellIcon } from '@heroicons/react/24/outline';

export function NotificationMenu() {
  return (
    <Menu as="div" className="relative">
      <MenuButton className="relative flex rounded-full text-gray-400 hover:text-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#274483] cursor-pointer">
        <span className="absolute -inset-1.5" />
        <span className="sr-only">{'View notifications'}</span>
        <BellIcon aria-hidden="true" className="size-6" />
      </MenuButton>
      <MenuItems
        transition
        className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg outline outline-black/5 transition data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-75 data-leave:ease-in cursor-pointer"
      >
        <MenuItem>
          <span className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:outline-hidden">
            {'No new notifications'}
          </span>
        </MenuItem>
      </MenuItems>
    </Menu>
  );
}
